import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h6 q-ml-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "helper" }, null, -1)
const _hoisted_3 = {
  key: 0,
  style: {"cursor":"pointer","margin":"30px 0px","font-size":"20px"},
  class: "btn display-inline"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "34",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12 2C12.5523 2 13 2.44772 13 3L13 12.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L11 12.5858V3C11 2.44772 11.4477 2 12 2ZM3 14C3.55228 14 4 14.4477 4 15V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V15C2 14.4477 2.44772 14 3 14Z",
    fill: "white"
  })
], -1)
const _hoisted_5 = {
  key: 1,
  class: "q-mt-md text-center download-text additional-text"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "remove-btn" }
const _hoisted_9 = { class: "q-my-md text-center" }
const _hoisted_10 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    class: "edit-dialog",
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showDialog) = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { style: {"min-width":"350px","background-color":"#151A27 !important"} }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row justify-between items-center" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('dialogs.avatarEdit.title')), 1),
              _createElementVNode("div", null, [
                _createVNode(_component_q_btn, {
                  "no-caps": "",
                  icon: "close",
                  flat: "",
                  rounded: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-py-none q-px-xl" }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createElementVNode("div", {
                class: "drop flex column items-center justify-center",
                onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
              }, [
                (!_ctx.image)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
                      _hoisted_4,
                      _createVNode(_component_vue_feather, {
                        class: "drop-image",
                        type: "image"
                      }),
                      _createElementVNode("input", {
                        type: "file",
                        name: "image",
                        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
                      }, null, 32)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.image)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('dialogs.avatarEdit.info')), 1))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["display-inline align-center", { image: true }])
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("img", {
                          width: "84",
                          height: "84",
                          src: _ctx.image,
                          alt: "",
                          class: "img"
                        }, null, 8, _hoisted_7),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_q_icon, {
                            name: "close",
                            onClick: _ctx.removeFile
                          }, null, 8, ["onClick"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_q_icon, {
                          style: {"font-size":"18px"},
                          name: "done",
                          color: "green"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('dialogs.avatarEdit.done')), 1)
                    ]))
              ], 32)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, {
            align: "center",
            class: "q-mt-lg text-primary"
          }, {
            default: _withCtx(() => [
              (_ctx.image)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    disable: _ctx.loading,
                    loading: _ctx.loading,
                    "no-caps": "",
                    color: "primary",
                    label: _ctx.$t('dialogs.btn.edit'),
                    "text-color": "dark",
                    style: {"width":"100%"},
                    type: "submit",
                    onClick: _ctx.onSubmit
                  }, null, 8, ["disable", "loading", "label", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}